export default {
      id: "icon--chevron-up-usage",
      viewBox: "0 0 13.4 7.2",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--chevron-up-usage",
      toString: function () {
        return this.url;
      }
    }